import PersonaliaItem from "./PersonaliaItem";

const PersonaliaList = (props) => {
  const gegevensList = props.gegevens.map((gegeven) => (
    <PersonaliaItem
      key={gegeven.id}
      id={gegeven.id}
      geslacht={gegeven.geslacht}
      voorletters={gegeven.voorletters}
      voornaam={gegeven.voornaam}
      tussenvoegsel={gegeven.tussenvoegsel}
      achternaam={gegeven.achternaam}
      geboortedatum={gegeven.geboortedatum}
      geboorteplaats={gegeven.geboorteplaats}
      straat={gegeven.straat}
      huisnummer={gegeven.huisnummer}
      postcode={gegeven.postcode}
      woonplaats={gegeven.woonplaats}
      land={gegeven.land}
      email={gegeven.email}
      telefoon={gegeven.telefoon}
      mobiel={gegeven.mobiel}
      website={gegeven.website}
      overig={gegeven.overig}
      ip={gegeven.ip}
      hostname={gegeven.hostname}
      wijzigingsdatum={gegeven.wijzigingsdatum}
    />
  ));

  return (
    <div>
      <h1>Personalia</h1>
      <ul>{gegevensList}</ul>
    </div>
  );
};

export default PersonaliaList;